import React, {Component} from "react"
import {
    UncontrolledTooltip, Button
  } from 'reactstrap';
import JoinUNdata from "./data/JoinUNdata"
import { Emoji } from 'emoji-mart'


class JoinUN extends Component {
    constructor(props) {
      super(props);
      this.state = {
          year:1945,
          endyear:2019,
          index:0,
          interval:800,
      }
      this.handletoggle = this.handletoggle.bind(this);
    }
      handletoggle(){
        this.setState(prevState => {
            return {
                year: 1945
            }
        })
    }

    componentDidMount(){
        this.myInterval = setInterval(() => {
                this.setState(prevState =>({
                    year:prevState.year==2019?"2019":prevState.year+1,
            }))
        },this.state.interval)
    }

    componentWillUnmount(){
        clearInterval(this.myInterval)
    }

    render() {
        var happy=this.state.year;
        var customEmojis = [
            {
              name: 'flag-yu',
              short_names: ['flag-yu'],
              text: '',
              emoticons: [],
              custom:true,
              keywords: ['github'],
              imageUrl: 'https://github.githubassets.com/images/icons/emoji/octocat.png'
            }
          ]

        function JoinUN(dmin,dmax){

            let datum = JoinUNdata.filter(function(data){
                return(
                    (data.UNJoin >= dmin) && (data.UNJoin < dmax)
                )
            }).map(function(data){
                let isoval=':flag-'+data.iso.toLowerCase()+':';
                let idvale="ide"+data.iso;
                let classdata = data.UNJoin-1>=happy? "unflags D"+data.UNJoin:"D"+data.UNJoin;
                // let classdata = "unflags D"+data.UNJoin
                return(
                    <span id={idvale} className={classdata}>
                         {/* <Picker icons={customIcons} /> */}
                        <Emoji custom={customEmojis} emoji={isoval} size={24} />
                        <UncontrolledTooltip placement="top" target={idvale}>
                        {data.countryAR} : {data.UNJoin} {data.commentAR}
                        </UncontrolledTooltip>
                    </span>
                    
                )
            })
            return datum;
        }

    return(
    <div>
        
        <p className="display-2 nomargin text-right">{this.state.year} </p>
        {/* <p className="text-left marginb10">{this.state.inject}</p> */}
        <p className="stem text-right margin-5">{JoinUN(this.props.year1,this.props.year2)}</p>
        <Button size="sm" style={{float:"right", marginTop:"12px", marginRight:"10px"}} onClick={this.handletoggle} outline color="secondary">استعرض مرة أخرى</Button>{' '}
    </div>
    )
    }          
}
export default JoinUN

